<template>
  <div class="masthead">
    <div class="background"></div>
    <LocaleChanger />
    <div class="container">
      <div class="row h100">
        <div class="col-lg-12 my-auto">
          <div class="header-content mx-auto">
            <div class="info">
              <div class="brand">
                <img class="logo" src="./../assets/logo.png" alt="logo" />
                <div class="subject">
                  <div class="app-name">JavDB</div>
                </div>
              </div>
              <div class="app-slogan" v-html="$t('subtitle')">
              </div>
            </div>
          </div>
          <div class="download-container">
            <a
              href="javascript:;"
              class="btn"
              v-on:click="showQrcodeModel()"
              v-if="this.osName != 'android' && this.osName != 'ios'"
            >
              <div class="label">
                {{ $t("download") }}<span>{{ this.appCurrentVersion }}</span>
              </div>
            </a>
            <a
              href="javascript:;"
              v-bind:class="{
                btn: true,
                'btn-download': true,
                liquid: true,
                disabled: this.osName == 'ios' && !this.$enabledIos,
              }"
              v-on:click="download()"
              v-if="this.osName == 'android' || this.osName == 'ios'"
            >
              <div
                class="label"
                v-if="
                  this.$enabledIos == true ||
                    (this.osName == 'android' && this.$enabledIos == false)
                "
              >
                {{ buttonText }}<span>{{ this.appCurrentVersion }}</span>
              </div>
              <div
                class="label"
                v-if="this.osName == 'ios' && this.$enabledIos == false"
              >
                {{ $t("ios_cert_repairing") }}
              </div>
            </a>
            <!--<a href="javascript:;" v-bind:class="{ btn: true, 'btn-download': true, disabled: (this.osName == 'ios' && !this.$enabledIosAppStore) }" v-on:click="showAppStoreLightVersionModel()" v-if="this.osName == 'ios' && this.$enabledIosAppStore">
              <div class="label">{{ $t("app_store_light_version") }}</div>
            </a>-->
          </div>
          <div class="download-container text-link mt-xl">
            <a v-bind:href="this.$officialUrl" class="btn" target="_blank">
              <div class="label">👨‍💻 {{ $t("web_version") }}</div>
            </a>
            <a v-bind:href="this.$telegramChannel" class="btn" target="_blank">
              <div class="label">🔈 {{ $t("telegram_channel") }}</div>
            </a>
            <br />
            <a v-on:click="showFqaModel()" class="btn" target="_blank">
              <div class="label">💡 {{ $t("fqa") }}</div>
            </a>
            <a
              href="https://github.com/bdvajstudio/javdb/releases"
              class="btn"
              target="_blank"
            >
              <div class="label">⬇️&nbsp;&nbsp;{{ $t("github_download") }}</div>
            </a>
          </div>
        </div>
        <!-- <div class="col-lg-12 my-auto alert-message success" v-if="this.osName == 'ios' || this.osName == 'android'"><div class="content" v-html="this.$t('notice_message')"></div></div> -->
        <div
          class="col-lg-12 my-auto alert-message"
          v-if="this.osName == 'ios'"
        >
          <div class="content" v-html="this.$t('ios_disabled_message')"></div>
        </div>

        <!--<div
          class="col-lg-12 my-auto alert-message"
          v-if="this.osName == 'android'"
        >
          <div class="content">
            ⚠️ 大陸地區下載正在修復中, 請一小時後再嘗試。
          </div>
        </div>-->

        <!-- screenshot -->
        <div class="col-lg-12 my-auto">
          <div class="device-container">
            <div class="portrait">
              <Carousel />
            </div>
          </div>
        </div>
      </div>
    </div>
    <QrcodeModal
      @hideQrcodeModal="hideQrcodeModal"
      v-show="qrcodeModalShowing"
      v-bind:channel="channel"
      v-bind:platform="platform"
      v-bind:invitationCode="invitationCode"
      v-bind:title="qrcodeTitle"
      v-bind:showQrcode="qrcodeShowing"
    />
    <FqaModal @hideFqaModal="hideFqaModal" v-show="fqaModalShowing" />
    <AppStoreLightVersionModal
      @hideAppStoreLightVersionModal="hideAppStoreLightVersionModel"
      v-show="appstoreLightVersionModalShowing"
    />

    <TestflightModal
      @hideTestflightModal="hideTestflightModal"
      v-show="testflightModalShowing"
      v-bind:title="testflightTitle"
    />
  </div>
</template>

<script>
import LocaleChanger from "./LocaleChanger.vue";
import TestflightModal from "./TestflightModal.vue";
import FqaModal from "./FqaModal.vue";
import QrcodeModal from "./QrcodeModal.vue";
import AppStoreLightVersionModal from "./AppStoreLightVersionModal.vue";
import Carousel from "./Carousel.vue";
import DeviceDetector from "device-detector-js";

export default {
  name: "Universal",
  components: {
    LocaleChanger,
    QrcodeModal,
    AppStoreLightVersionModal,
    TestflightModal,
    Carousel,
    FqaModal,
  },
  props: {},
  computed: {
    iosButtonText: function() {
      if (this.$enabledIos) {
        return `iOS ${this.$t("download_self_sign")}`;
      } else {
        return `iOS ${this.$t("ios_cert_repairing")}`;
      }
    },
    buttonText: function() {
      if (this.osName == "ios") {
        if (this.$enabledIos) {
          return `iOS ${this.$t("download_self_sign")}`;
        } else {
          return `iOS ${this.$t("ios_cert_repairing")}`;
        }
      } else {
        return this.$t("download");
      }
    },
    appCurrentVersion: function() {
      let version = "";
      if (this.osName == "ios") {
        version = this.$iosVersion;
      } else if (this.osName == "android") {
        version = this.$version;
      }
      return version == "" ? "" : ` (${version})`;
    },
  },
  data: function() {
    return {
      channel: "official",
      osName: "",
      invitationCode: null,
      qrcodeShowing: false,
      qrcodeModalShowing: false,
      fqaModalShowing: false,
      appstoreLightVersionModalShowing: false,
      testflightModalShowing: false,
      qrcodeTitle: this.$t("please_use_phone_install"),
      testflightTitle: this.$t("follow_step_to_install"),
      platform: "ios",
    };
  },
  created: function() {
    const deviceDetector = new DeviceDetector();
    const device = deviceDetector.parse(navigator.userAgent);
    this.osName = device.os.name.toLowerCase();
    this.platform = this.osName;
    const queryString = window.location.search;
    if (queryString) {
      const urlParams = new URLSearchParams(queryString);
      this.invitationCode = urlParams.get("source");
      this.channel = this.common.verifyChannel(urlParams.get("channel"));
    }
  },
  methods: {
    hideQrcodeModal: function() {
      this.qrcodeShowing = false;
      this.qrcodeModalShowing = false;
    },
    hideTestflightModal: function() {
      this.testflightModalShowing = false;
    },
    showQrcodeModel: function() {
      this.qrcodeShowing = true;
      this.qrcodeModalShowing = true;
    },
    showFqaModel: function() {
      this.fqaModalShowing = true;
    },
    hideFqaModal: function() {
      this.fqaModalShowing = false;
    },
    showAppStoreLightVersionModel: function() {
      this.appstoreLightVersionModalShowing = true;
    },
    hideAppStoreLightVersionModel: function() {
      this.appstoreLightVersionModalShowing = false;
    },
    download: function() {
      if (this.osName == "ios" && !this.$enabledIos) {
        this.$toast.error(this.$t("ios_disabled_message"), {
          duration: 9000,
          position: "top",
        });
        return false;
      }
      if (this.osName == "android") {
        let clipboardData = {
          astarte: true,
          channel: this.channel,
          invitecode: "",
        };
        if (this.invitationCode) {
          clipboardData.invitecode = this.invitationCode;
        }
        // const encodeCode = `**:${this.invitationCode}:**`;
        const encodeCode = JSON.stringify(clipboardData);
        let textArea = document.createElement("textarea");
        textArea.value = encodeCode;
        textArea.style.width = "1px";
        textArea.style.height = "1px";
        document.body.appendChild(textArea);
        textArea.select();
        console.log("copy data: ", encodeCode);
        // const cb = navigator.clipboard;
        // cb.writeText(textArea.value).then(() => { console.log('copy success')});
        try {
          document.execCommand("copy");
          document.body.removeChild(textArea);
        } catch (err) {
          console.log("Oops, unable to copy");
        }
        window.location.href = this.$apkUrl;
      }

      if (this.channel) {
        if (this.osName == "android") {
          this.qrcodeTitle = this.$t("downloading_title");
          this.qrcodeShowing = false;
          this.qrcodeModalShowing = true;
        } else if (this.osName == "ios") {
          // this.qrcodeTitle = this.$t("ios_installation");
          // this.testflightModalShowing = true;
          window.location.href = this.$iosSelfSignedUrl;
        }
      }
    },
  },
};
</script>

<style lang="scss">
html {
  line-height: 1.15; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
}
body {
  margin: 0;
}

main {
  display: block;
}
a {
  text-decoration: none;
}
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

hr {
  box-sizing: content-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
}

pre {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

a {
  background-color: transparent;
}

abbr[title] {
  border-bottom: none; /* 1 */
  text-decoration: underline; /* 2 */
  text-decoration: underline dotted; /* 2 */
}

b,
strong {
  font-weight: bolder;
}

code,
kbd,
samp {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

small {
  font-size: 80%;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

img {
  border-style: none;
}

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
}

button,
input {
  /* 1 */
  overflow: visible;
}

button,
select {
  /* 1 */
  text-transform: none;
}

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}
button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}
fieldset {
  padding: 0.35em 0.75em 0.625em;
}
legend {
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}
progress {
  vertical-align: baseline;
}

textarea {
  overflow: auto;
}
[type="checkbox"],
[type="radio"] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}
[type="search"] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

details {
  display: block;
}
summary {
  display: list-item;
}
template {
  display: none;
}
[hidden] {
  display: none;
}
a:-webkit-any-link {
  text-decoration: none;
}
*,
::after,
::before {
  box-sizing: border-box;
}
html {
  font-family: sans-serif;
  -webkit-tap-highlight-color: transparent;
}
body {
  height: 100%;
  background-color: #1a1722;
  color: #f2f2f2;
  height: 100%;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;
}
.container,
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.row {
  display: flex;
  flex: 1 0 100%;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}
.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}
.mt-auto,
.my-auto {
  margin-top: auto !important;
}
.col,
.col-1,
.col-10,
.col-11,
.col-12,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-auto,
.col-lg,
.col-lg-1,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-auto,
.col-md,
.col-md-1,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-auto,
.col-sm,
.col-sm-1,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-auto,
.col-xl,
.col-xl-1,
.col-xl-10,
.col-xl-11,
.col-xl-12,
.col-xl-2,
.col-xl-3,
.col-xl-4,
.col-xl-5,
.col-xl-6,
.col-xl-7,
.col-xl-8,
.col-xl-9,
.col-xl-auto {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
.ml-auto,
.mx-auto {
  margin-left: auto !important;
}
.mr-auto,
.mx-auto {
  margin-right: auto !important;
}
.masthead {
  position: relative;
  width: 100%;
  padding-bottom: 100px;
  min-height: 1800px;
  .background {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url(./../assets/bg.jpg) no-repeat;
    background-size: 100% auto;
  }
  .container {
    padding-top: 3rem;
  }
  .header-content {
    max-width: 900px;
    margin-bottom: 2rem;
    text-align: center;
    display: block;
    width: 100%;
    .info {
      .brand {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        text-align: center;
        .logo {
          width: 3rem;
          height: 3rem;
          margin-right: 0.5rem;
          border-radius: 10px;
        }
        .subject {
          padding-left: 0.4rem;
          display: grid;
          place-items: center;
          .app-name {
            font-size: 2.6rem;
            font-weight: bold;
            text-align: center;
            line-height: 1.8rem;
          }
        }
      }
    }
    .app-slogan {
      padding-top: 2rem;
      font-size: 1.4rem;
      text-align: center;
      line-height: 2.4rem;
    }
    .qrcode {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      z-index: 5;
      padding-top: 1.2rem;
      img {
        width: 140px;
        height: auto;
        border: 3px solid #fff;
        border-radius: 16px;
      }
      .notice {
        padding-top: 0.4rem;
      }
    }
  }
  .mt-xl {
    margin-top: 1.2rem;
  }
  .mt-md {
    margin-top: 0.6rem;
  }
  .download-container {
    display: flex;
    justify-content: center;
    &.text-link .btn {
      cursor: pointer;
      position: relative;
      white-space: nowrap;
      display: flex;
      border: none;
      background: none;
      padding: 0.1rem 0.2rem;
      margin-right: 1rem;
      cursor: pointer;
      border-radius: 0;
      box-shadow: none;
      .label {
        font-size: 0.9rem;
        color: #ccc;
        font-weight: normal;
      }
      &::before {
        content: "";
        position: absolute;
        display: block;
        width: 100%;
        height: 2px;
        bottom: 0;
        left: 0;
        background-color: #cc1c71;
        transform: scaleX(0);
        transition: transform 0.3s ease;
      }
      &:hover {
        background: none;
        color: #fff;
        box-shadow: none;
        .label {
          color: #fff;
          transform: translate3d(0, -2px, 0);
        }
        &::before {
          transform: scaleX(1);
        }
      }
      &:last-child {
        margin-right: 0;
      }
    }
    .btn.disabled {
      .label {
        color: #6e1955;
      }
    }
    .btn {
      display: flex;
      border-radius: 0.15em;
      background: #cc1c71;
      box-shadow: inset 0 -0.6em 0 -0.35em rgba(0, 0, 0, 0.3);
      padding: 0.8rem 1.6rem;
      margin-right: 1rem;
      cursor: pointer;
      text-decoration: none;
      position: relative;
      align-items: center;
      &:hover {
        top: -0.1em;
        background: #dd2980;
        box-shadow: inset 0 -0.6em 0 -0.35em rgba(0, 0, 0, 0.3);
      }
      &:active {
        top: 0.1em;
        background: #bd1a69;
        box-shadow: inset 0 -0.6em 0 -0.35em rgba(0, 0, 0, 0.3);
      }
      &:last-child {
        margin-right: 0;
      }
      span {
        font-size: 1rem;
        color: #eee;
      }
      .icon {
        padding-right: 5px;
        svg {
          margin-top: 4px;
          width: 16px;
          height: 16px;
        }
        img {
          width: 30px;
          height: auto;
        }
      }
      .label {
        line-height: 2rem;
        font-size: 1.2rem;
        color: #f2f2f2;
        font-weight: bold;
      }
    }
  }
  .device-container {
    padding-top: 1.5rem;
    img {
      max-width: 600px;
    }
  }
}

@media (max-width: 992px) {
  .masthead {
    height: 100vh;
    min-height: 900px;
    padding-bottom: 100px;
    .container {
      padding-top: 60px;
    }
    .header-content {
      margin-bottom: 0;
      text-align: left;
      .info {
        width: 100%;
        .app-slogan {
          text-align: center;
        }
      }
    }
    .download-container {
      margin-bottom: 2.4rem;
    }
    .device-container img {
      max-width: 98%;
    }
  }
}

@media (max-width: 450px) {
  .masthead {
    height: 100vh;
    min-height: 900px;
    padding-bottom: 100px;
    .header-content {
      margin-bottom: 0;
      text-align: left;
      .info {
        width: 100%;
        .app-slogan {
          text-align: center;
        }
      }
    }
    .download-container {
      display: block;
      text-align: center;
      &.text-link {
        .btn {
          display: inline-block;
          border: none;
          border-bottom: 1px solid #ff50a4;
          background: none;
          padding: 0.1rem 0.2rem 0 0.2rem;
          margin-right: 1rem;
          cursor: pointer;
          text-align: center;
          &:last-child {
            margin-right: 0;
          }
        }
      }
      .btn {
        padding: 0.4rem 1rem;
        display: block;
        margin-right: 0;
        margin-bottom: 0.4rem;
        &:last-child {
          margin-bottom: 0;
        }
        .icon img,
        .icon svg {
          width: 20px;
        }
        .label {
          font-size: 1.4rem;
          line-height: 1.8rem;
        }
      }
      margin-bottom: 1rem;
    }
    .device-container img {
      max-width: 98%;
    }
  }
}
.alert-message {
  .content {
    background: #faeb8d;
    color: #333;
    padding: 0.4rem 1rem;
    border-radius: 3px;
    font-size: 0.8rem;
    text-align: left;
    margin-bottom: 1rem;
    a,
    a:visited {
      color: #dd2980;
    }
  }
}
.alert-message.success .content {
  background: #38754b;
  color: #fff;
}
</style>
